import { Produto } from '../../model/Produto';
import { ProdutoService } from '../../service/produto.service';
import { Component, OnInit } from '@angular/core';
import { ICadBase } from '../../model/ICadBase';
import { State } from '../../model/enumState';
import { MensagemService } from '../../service/mensagem.service';

@Component({
  selector: 'app-cad-produto',
  templateUrl: './cad-produto.component.html',
  styleUrls: ['./cad-produto.component.css']
})
export class CadProdutoComponent implements ICadBase, OnInit {

  public mostrar: boolean = true;
  constructor(public service: ProdutoService, private msg: MensagemService) { }

  title: string = "Produto";
  titleExcluindo: string = "o produto";
  nome: string = "produto"
  ngOnInit() {
  }

  beforeSave(item, estado: State) {

  }
  public afterSave(item, that, calback) {
    return false;
  }

  NovoItem(item): any {
    var it = new Produto();
    if (item) {
      it.Assing(item);
    }
    else {
      it.ativo = true;
    }

    return it;

  }

  public InserindoAssincrono(item, that, calback, CancelLoading) {
    return false;
  }
  public EditandoAssincrono(item, that, calback) {
    return false;
  }

  public validoParaInserir(item): boolean {
    var rt = true;
    //Descricao, Codigo, CodTabela, preco, tipo
    if (rt) {
      if (!item.Descricao) {
        rt = false;
        this.msg.Error("Nome deve ser informado");
      }
    }
    if (rt) {
      if (!item.Codigo) {
        rt = false;
        this.msg.Error("Código deve ser informado");
      }
    }
    if (rt) {
      if (!item.CodTabela) {
        rt = false;
        this.msg.Error("Tabela deve ser informada");
      }
    }
    if (rt) {
      if (!item.preco) {
        rt = false;
        this.msg.Error("Preço deve ser informado");
      }
    }
    if (rt) {
      if (!item.tipo) {
        rt = false;
        this.msg.Error("Tipo deve ser informado");
      }
    }
    if (rt) {
      if (!item.empresa) {
        rt = false;
        this.msg.Error("Empresa deve ser informada");
      }
    }

    return rt;
  }
  public validoParaEditar(item): boolean {
    return this.validoParaInserir(item);
  }

  EstadoChange(state: State) {

  }

}
